import React from 'react';
import spinnerGraphic from './assets/loading-dots.gif';
import './styles.css';

const LoadingSpinner = (props) => (
  <div className={`loading-spinner ${props.className || ''}`} style={props.style}>
    <div className="spinner-graphic">
      <img src={spinnerGraphic} alt="loading"/>
    </div>
    <div>{props.message === undefined ? 'Loading...' : props.message}</div>
  </div>
);

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner/index.js